import styled from "@emotion/styled";
import type { StepLiquidityPool } from "@stepfinance/liquidity";
import { getLiquidityPoolName } from "@stepfinance/liquidity";
import type { NormalizedTokenAccount } from "@stepfinance/tokens";
import { Tooltip } from "antd";
import type { FC } from "react";

import { useLPRatio } from "../../hooks";
import { getTotalLiquidityInUSD } from "../../utils/pools/utils";
import { formatUSD } from "../../utils/utils";
import { TokenIcon } from "../TokenIcon";

export type PoolInfoHeaderProps = {
  pool: StepLiquidityPool;
  accounts: NormalizedTokenAccount[];
  className?: string;
  hasUntrackableValue: boolean;
};

export const PoolInfoHeader: FC<PoolInfoHeaderProps> = ({ pool, accounts, className, hasUntrackableValue }) => {
  const ratio = useLPRatio(pool, accounts);

  const mintA = pool.mints[0];
  const mintB = pool.mints[1];
  const poolValue = formatUSD.format(ratio * getTotalLiquidityInUSD(pool.liquidityInUSD));

  const untrackedMessage =
    "We do not track the price of unknown tokens, and so cannot show the value of the pools that include them.";
  const untrackedValueToolTip = (
    <Tooltip title={untrackedMessage} placement="bottom">
      Value not tracked
    </Tooltip>
  );
  return (
    <PoolPanelHeader className={className}>
      <YourPoolInfoContainer>
        {mintA && mintB && <TokenIcon mintAddress={[mintA, mintB]} />}
        <span>{getLiquidityPoolName(pool)}</span>
      </YourPoolInfoContainer>
      <PoolAmountSpan>{hasUntrackableValue ? untrackedValueToolTip : poolValue}</PoolAmountSpan>
    </PoolPanelHeader>
  );
};

const PoolPanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const YourPoolInfoContainer = styled.div`
  display: flex;
  align-items: center;

  span {
    font-size: 14px;
  }
`;

export const PoolAmountSpan = styled.span`
  font-size: 14px;
  font-weight: 700;
`;
